export default {
  "click-outside": {
    bind: function (el, binding, vNode) {
      if (typeof binding.value !== "function") {
        const compName = vNode.context.name
        let warn =
          "[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be"
        if (compName) {
          warn += "Found in component '${compName}'"
        }
        console.warn(warn)
      }
      const bubble = binding.modifiers.bubble
      const handler = (e) => {
        if (bubble || (!el.contains(e.target) && el !== e.target)) {
          binding.value(e, vNode.key)
        }
      }
      el.__vueClickOutside__ = handler
      document.addEventListener("click", el.__vueClickOutside__)
      document.addEventListener("touchstart", el.__vueClickOutside__)
    },
    unbind: function (el, binding) {
      document.removeEventListener("click", el.__vueClickOutside__)
      document.removeEventListener("touchstart", el.__vueClickOutside__)
      el.__vueClickOutside__ = null
    },
  },
}
